// context/ModalContext.js
import React, { createContext, useState, useContext } from 'react'

const SideModalContext = createContext()

export const useModal = () => useContext(SideModalContext)

export const SideModalProvider = ({ children }) => {
	const [modalContent, setModalContent] = useState(null)
	const [isOpen, setIsOpen] = useState(false)

	const openModal = (content) => {
		setModalContent(content)
		setIsOpen(true)
	}

	const closeModal = () => {
		setIsOpen(false)
		setModalContent(null)
	}

	return (
		<SideModalContext.Provider value={{ modalContent, isOpen, openModal, closeModal }}>
			{children}
		</SideModalContext.Provider>
	)
}
